export default __webpack_public_path__ + "static/watch-icon-aef64f7ec11411acddf8c89cf3b3e788.png";